// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"ff020085","446":"c24e49a9","611":"d0536213","661":"9314ff01","787":"e0df85ef"}[chunkId] + ".chunk.js";
};